module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row row-fix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
    staticClass: "alert alert-info alert-dismissible margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Informação!")]), _vm._v("\n              " + _vm._s(_vm.leadClient ?
    "Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000" :
    "Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.") + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em\n              breve entraremos em contato para finalizar a adesão, obrigado!\n            ")]) : _vm._e(), _vm._v(" "), (
    _vm.formState == 'LEAD-INFO' ||
    _vm.formState == 'NEW' ||
    _vm.formState == 'ERROR'
  ) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxpayerIdNumber')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "taxpayerIdNumber"
    }
  }, [_vm._v("\n                  CNPJ*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxpayerIdNumber),
      expression: "taxpayerIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "name": "taxpayerIdNumber",
      "id": "taxpayerIdNumber",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.taxpayerIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxpayerIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("taxpayerIdNumber")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("\n                  Empresa*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "companyName",
      "id": "companyName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("companyName")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "contactName",
      "required": ""
    }
  }, [_vm._v("\n                  Nome do Contato*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName",
      "id": "contactName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactName")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmail')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "contactEmail"
    }
  }, [_vm._v("\n                  E-mail*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmail",
      "id": "contactEmail",
      "data-vv-rules": "required|email|email:email"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactEmail")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactJobTitle')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "contactJobTitle"
    }
  }, [_vm._v("\n                  Telefone*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.contactJobTitle),
      expression: "contactJobTitle",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|generalMask'),
      expression: "'required|generalMask'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactJobTitle",
      "id": "contactJobTitle"
    },
    domProps: {
      "value": (_vm.contactJobTitle)
    },
    on: {
      "change": function($event) {
        _vm.contactJobTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactJobTitle")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('sizeOfFleetVehicle')
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "sizeOfFleetVehicle"
    }
  }, [_vm._v("\n                  Tamanho da Frota*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sizeOfFleetVehicle),
      expression: "sizeOfFleetVehicle"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "sizeOfFleetVehicle",
      "id": "sizeOfFleetVehicle",
      "data-vv-rules": "required|decimal|max:6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.sizeOfFleetVehicle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sizeOfFleetVehicle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block-proposal help-block with-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("sizeOfFleetVehicle")) + "\n                  ")])])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Solicitar Proposta")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', [_vm._v("\n        Que legal você ter interesse em ser mais, para isto preencha os dados\n        abaixo que vamos analisar e retornar o mais breve possível uma\n        proposta!\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-4 col-sm-8 pad-fix"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-enviar",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Enviar informações\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "img-contact",
    attrs: {
      "src": require("../../assets/img/img-deal.svg"),
      "alt": "Proposta"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-56d9235d!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/proposal.vue
// module id = 2132
// module chunks = 1